import dayjs from "@/utils/dayjsConfig";
import { useEffect, useState } from "react";

const useTimeCounter = ({ publishDate }: { publishDate: Date | string }): string => {
  const [timeSince, setTimeSince] = useState("");

  useEffect(() => {
    // Calculate the time difference between now and the publishing date
    const calculateTimeSince = () => {
      const now = dayjs();
      const publishedAt = dayjs(publishDate);
      const duration = dayjs.duration(now.diff(publishedAt));

      const years = duration.years();
      const months = duration.months();
      const days = duration.asDays();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      let timeSinceString = "";
      if (years >= 1) {
        setTimeSince((timeSinceString += `${Math.floor(years)}y ago`).trim());
        return;
      }
      if (months >= 1) {
        setTimeSince((timeSinceString += `${Math.floor(months)}mo ago`).trim());
        return;
      }
      if (days >= 1) {
        setTimeSince((timeSinceString = `${Math.floor(days)}d ago`).trim());
        return;
      }
      if (hours >= 1) {
        setTimeSince((timeSinceString = `${Math.floor(hours)}h ago`).trim());
        return;
      }
      if (minutes >= 1) {
        setTimeSince((timeSinceString = `${Math.floor(minutes)}m ago`).trim());
        return;
      }
      if (seconds >= 1) {
        setTimeSince((timeSinceString = `${Math.floor(seconds)}s ago`).trim());
        return;
      }
    };

    calculateTimeSince();

    const intervalId = setInterval(() => {
      calculateTimeSince();
    }, 60000);

    return () => clearInterval(intervalId);
  }, [publishDate]);

  return timeSince;
};

export default useTimeCounter;
